import { useMerklUserRewards } from '@app/hooks/merkl/useMerklUserRewards';
import { useMemo } from 'react';
import uniq from 'lodash/uniq';
import { useTokensPricesV4 } from '@app/hooks/merkl/useTokensPricesV4';
import { formatUnits } from 'ethers/lib/utils';
import { useMerklCampaigns } from '@app/hooks/merkl/useMerklCampaigns';

export function useMarketMakerTokensDetails() {
  const { data: campaigns } = useMerklCampaigns({ showExpired: true });

  const rewardsChainIds = useMemo(() => {
    if (!campaigns) {
      return [];
    }

    return uniq(campaigns.map(c => c.chainId));
  }, [campaigns]);

  const { data, isLoading } = useMerklUserRewards(rewardsChainIds);

  const rewardTokens = useMemo(() => {
    if (!data) {
      return [];
    }

    return uniq(
      Object.keys(data).map(key => {
        const d = data[key];

        return d.symbol;
      })
    );
  }, [data]);

  const prices = useTokensPricesV4(rewardTokens);

  const totalValue = useMemo(() => {
    if (!data) {
      return;
    }

    return Object.values(data).reduce((res, item) => {
      const { symbol, decimals, unclaimed } = item;

      const amount = formatUnits(unclaimed, decimals);

      res += unclaimed && prices[symbol] ? prices[symbol] * +amount : 0;

      return res;
    }, 0);
  }, [data, prices]);

  return {
    isLoading: isLoading,
    totalUSD: totalValue,
    tokensSymbols: rewardTokens,
    userRewards: data,
    rewardsChainIds
  };
}
